(() => {
  if (window.CrownProductSpecifications) return;
  window.CrownProductSpecifications = true;

  const rootSelector = ".product-specifications";
  const rowSelector = ".product-specifications__row";

  const normalizeText = (value) =>
    String(value || "")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();

  const dimensionConcept = (label) => {
    const normalized = normalizeText(label);
    if (/^(?:chain|bracelet|anklet|item)?\s*length$/.test(normalized)) return "length";
    if (/^(?:chain|bracelet|anklet|item)?\s*width$/.test(normalized)) return "width";
    return "";
  };

  const productKind = (root) => {
    const rows = [...root.querySelectorAll(rowSelector)];
    for (const requestedLabel of ["jewelry type", "product type"]) {
      for (const row of rows) {
        const label = normalizeText(row.querySelector("dt")?.textContent);
        if (label === requestedLabel) {
          const value = normalizeText(row.querySelector("dd")?.textContent);
          if (value) return value;
        }
      }
    }
    return "";
  };

  const labelPriority = (label, kind) => {
    const normalized = normalizeText(label);
    if (normalized === "length" || normalized === "width") return 0;
    if (normalized.startsWith("item ")) return 1;
    if (
      (kind.includes("bracelet") && normalized.startsWith("bracelet ")) ||
      (kind.includes("anklet") && normalized.startsWith("anklet ")) ||
      ((kind.includes("chain") || kind.includes("necklace")) && normalized.startsWith("chain "))
    ) {
      return 3;
    }
    return 2;
  };

  const deduplicateList = (list, kind) => {
    const duplicateGroups = new Map();

    for (const row of list.querySelectorAll(`:scope > ${rowSelector}`)) {
      const label = row.querySelector("dt")?.textContent || "";
      const value = normalizeText(row.querySelector("dd")?.textContent);
      const concept = dimensionConcept(label);
      if (!concept || !value) continue;

      const key = `${concept}\u0000${value}`;
      const candidates = duplicateGroups.get(key) || [];
      candidates.push({ row, label });
      duplicateGroups.set(key, candidates);
    }

    for (const candidates of duplicateGroups.values()) {
      if (candidates.length < 2) continue;

      const preferred = candidates.reduce((best, candidate) =>
        labelPriority(candidate.label, kind) > labelPriority(best.label, kind) ? candidate : best
      );

      for (const candidate of candidates) {
        if (candidate !== preferred) candidate.row.remove();
      }
    }
  };

  const deduplicateRoot = (root) => {
    const kind = productKind(root);
    for (const list of root.querySelectorAll(".product-specifications__list")) {
      deduplicateList(list, kind);
    }
  };

  const processScope = (scope) => {
    if (!(scope instanceof Element || scope instanceof Document)) return;
    if (scope instanceof Element && scope.matches(rootSelector)) deduplicateRoot(scope);
    for (const root of scope.querySelectorAll(rootSelector)) deduplicateRoot(root);
  };

  const start = () => {
    processScope(document);

    const observer = new MutationObserver((records) => {
      const roots = new Set();
      for (const record of records) {
        const targetRoot = record.target.parentElement?.closest(rootSelector);
        if (targetRoot) roots.add(targetRoot);
        for (const node of record.addedNodes) {
          if (!(node instanceof Element)) continue;
          const addedRoot = node.matches(rootSelector) ? node : node.closest(rootSelector);
          if (addedRoot) roots.add(addedRoot);
          for (const nestedRoot of node.querySelectorAll(rootSelector)) roots.add(nestedRoot);
        }
      }
      for (const root of roots) deduplicateRoot(root);
    });

    observer.observe(document.documentElement, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();
